import createClassNames from 'classnames'

const DropdownLink = ({
    url,
    children,
    classNames,
    className = createClassNames(classNames),
    isExternalLink = false,
    ...props
}) =>
    isExternalLink ? (
        <a {...props} target="__blank" className={className} href={url}>
            {children}
        </a>
    ) : (
        <Link {...props} className={className} to={url}>
            {children}
        </Link>
    )

export default DropdownLink
